export default function SuccessIcon() {
  return (
    <svg
      width="24"
      height="24"
      className="ml-2"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="23" height="23" rx="11.5" fill="#35BD6E" />
      <g clipPath="url(#clip0_1287_19285)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9926 8.09283C17.3224 8.40628 17.3373 8.92942 17.0258 9.26131L10.8195 15.8738C10.6698 16.0333 10.4631 16.1264 10.2451 16.1325C10.0271 16.1386 9.81568 16.0572 9.65736 15.9063L6.00651 12.4261C5.67716 12.1121 5.6631 11.5889 5.97511 11.2575C6.28712 10.9261 6.80704 10.912 7.13638 11.2259L10.19 14.1368L15.8313 8.12622C16.1428 7.79434 16.6627 7.77939 16.9926 8.09283Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1287_19285">
          <rect
            width="11.5"
            height="11.5"
            fill="white"
            transform="translate(5.75 6.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
